import * as Model from '../../generated_models'
import { DependenciesState, FieldData, FormState, FormData, DependencyResult, SectionData, TabData, StepData, Map2, GenericDependencyOutput, UnmetDependencyOutput, DependencyData, NotReviewedDependencyOutput } from './types';
import * as Immutable from 'immutable'
import { loadingAsyncState } from 'widgets-for-react';
import { is_valid_postcode, is_valid_phone, is_valid_email, is_valid_date } from './validators';
import { async_queue, AsyncMonitor } from './async_monitor';
import * as IBAN from 'fast-iban'
// export type SchoolFormData = {
//   School: Model.School,
//   CareCoordinator: string,
//   Supervisor: string,
//   ContactPersonAdmissions: string,
//   ConfidentialCounselor: string
// }

export function zip<T1, T2>(arr1: T1[], arr2: T2[]): [T1, T2][] {
  if (arr1 == undefined || arr1 == null || arr1.length == 0 ||
    arr2 == undefined || arr2 == null || arr2.length == 0)
    return []
  return arr1.map((k, i) => [k, arr2[i]])
}

export let update_elem_in_list = (lst: any[], index: number, elem: any): any[] => {
  return lst.map((elem1, index1) => index == index1 ? elem : elem1)
}

export let get_associated_dependencies = (fieldData: FieldData, formState: FormState) => {
  let associated_dependencies: Immutable.Set<Model.Dependency> = Immutable.Set()
  if (formState.form_data.kind == "loaded") {
    formState.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => {
      s.dependencies.forEach(d => {
        d.dependent_fields.forEach(f => {
          if (f.FieldId == fieldData.field.Id) {
            associated_dependencies = associated_dependencies.add(d.dependency)
          }
        })
      })
    })))
  }
  return associated_dependencies.toList()
}

export let are_all_dependencies_met = (formState: FormState): boolean => {
  let are_dependencies_met = true
  if (formState.form_data.kind == "loaded") {
    formState.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(step => step.dependencies.forEach(dependency => {
      // if (dependency.dependency.lockSubmissionIfViolated && !is_dependency_met(dependency.dependency, formState))
      if (!is_dependency_met(dependency.dependency, formState))
        are_dependencies_met = false
    }))))
  }
  return are_dependencies_met
}

export let are_dependencies_met = (fieldData: FieldData, formState: FormState): GenericDependencyOutput => {

  let associated_dependencies = get_associated_dependencies(fieldData, formState)
  let messages = Immutable.Set<string>()
  let all_associated_dependencies_met = true
  let dependencies_state = formState.dependencies_state

  // associated_dependencies.filter(dependency => dependency.lockSubmissionIfViolated).forEach(dependency => {
  associated_dependencies.forEach(dependency => {
    let dependency_id = dependency.Id
    if (!dependencies_state.has(dependency_id)) return { kind: "no", messages: Immutable.Set<string>("unassociated dependency") }
    let dependency_fields = dependencies_state.get(dependency_id)
    if (dependency_fields.has(fieldData.field.Id)) {
      dependency_fields.forEach(state => {
        if (state.kind == "simple" && state.value == false) {
          messages = messages.add(dependency.title)
          all_associated_dependencies_met = false
        }
        if (state.kind == "async") {
          if (state.value.Result.kind != "unloaded") {
            if (state.value.Result.kind == "loaded") {
              if (!state.value.Result.value) {
                messages = messages.add(dependency.title)
                all_associated_dependencies_met = false
              }
            }
            else {
              messages = messages.add("Controleren...")
              all_associated_dependencies_met = false
            }
          }
        }
      })
    }
  })

  if (all_associated_dependencies_met) return { kind: "yes" }
  return { kind: "no", messages: messages.toList() }
}

export let get_text_from_draftjs = (input: string): string => {
  try {
    let text = Immutable.List<string>()
    let text_list = JSON.parse(input ? input : "")
    if (text_list["_immutable"] != undefined &&
      text_list["_immutable"]["currentContent"] != undefined &&
      text_list["_immutable"]["currentContent"]["blockMap"] != undefined) {
      text_list = text_list["_immutable"]["currentContent"]["blockMap"]
    }
    else {
      text_list = text_list.blocks
    }

    for (const [key, value] of Object.entries(text_list)) {
      let value1 = value as any
      text = text.push(value1.text)
    }
    let res = text.join(" ")

    return res
  }
  catch {
    return input == undefined ? '' : input
  }
}

export let is_dependency_met = (dependency: Model.Dependency, formState: FormState): boolean => {

  let messages = Immutable.List<string>()
  let is_dependency_met = true
  let dependencies_state = formState.dependencies_state

  let dependency_id = dependency.Id
  if (!dependencies_state.has(dependency_id)) return false
  let dependency_fields = dependencies_state.get(dependency_id)

  dependency_fields.forEach(state => {
    if (state.kind == "simple" && state.value == false) {
      messages = messages.push(dependency.title)
      is_dependency_met = false
    }
    if (state.kind == "async") {
      if (state.value.Result.kind != "unloaded") {
        if (state.value.Result.kind == "loaded") {
          if (!state.value.Result.value) {
            messages = messages.push(dependency.title)
            is_dependency_met = false
          }
        }
        else {
          messages = messages.push("Controleren...")
          is_dependency_met = false
        }
      }
    }
  })

  return is_dependency_met
}

export let get_dependency_result = (field: FieldData, input: string, extra_input: () => Immutable.List<string>, dependency: Model.Dependency, field_data_array: FieldData[], prevDependenciesStateMonitor?: AsyncMonitor<boolean>, showMinMaxWarning?: boolean): DependencyResult => {
  if (prevDependenciesStateMonitor == undefined)
    prevDependenciesStateMonitor = async_queue<boolean>({ key: `dependency_async_${field.field.Id}_${dependency.Id}` })()
  // if (input == undefined)
  //   input = ""
  let isNumeric = (num: any) => {
    return num != "" && !isNaN(num)
  }
  if (dependency.Kind == "Filled") {  
    if (field.field.Kind == "Text" || field.field.Kind == "TextArea") {
      input = get_text_from_draftjs(input)
    }
    // if (input.length > 0 && input.trim().length == 0) {
    //   input = ""
    // }
    if (field.field.Kind == 'TextInputTable') {
      let all_filled = 0
      let table_input = ParseTableMap(field.user_input)
      let nested = Array.from(table_input.values())
      nested.forEach(memo => Array.from(memo.values()).forEach(str => {
        if (str && str.length > 0)
          all_filled++
      }))
      return { kind: "simple", value: all_filled == field.maybe_labels.length * field.maybe_answers.length }
    }
    return { kind: "simple", value: field.field.Kind == 'RadioOptionTable' ? field.maybe_labels.map(label => input.replace(/\\"/g, '"').includes(`${label.label} -`)).every(bool => bool) : input != undefined && input != "" }
  }
  if (dependency.Kind == "GreaterThan") {
    if (!isNumeric(input) || !isNumeric(dependency.value)) return { kind: "simple", value: false }
    let value = +input
    let test = +dependency.value
    return { kind: "simple", value: input && value > test }
  }
  if (dependency.Kind == "DifferentThan") {
    return { kind: "simple", value: input && input != dependency.value }
  }
  if (dependency.Kind == "IsEmail") {
    let res = input && is_valid_email(input)
    if (res == undefined) res = false
    return { kind: "simple", value: res }
  }
  if (dependency.Kind == "IsNumber") {
    try {
      return { kind: "simple", value: isNumeric(JSON.parse(input).blocks[0].text) }
    } catch (_) {
      return { kind: "simple", value: input && input != "" && isNumeric(input) }
    }
  }
  if (dependency.Kind == "IsCapital") {
    return { kind: "simple", value: input && input != "" && /^[A-Z]/.test(input) }
  }
  if (dependency.Kind == "Action") {
    dependency.Action(field_data_array)
    return { kind: "simple", value: true }
  }
  if (dependency.Kind == "IsIBAN") {

    //return { kind: "simple", value: false }
    try {
      return { kind: "simple", value: IBAN.validateIBAN(input) }
    } catch (_) {
      return { kind: "simple", value: false }
    }
  }


  if (dependency.Kind == "IsPhoneNumber") {
    //Phone check in ./validators in a separate function
    try {
      return { kind: "simple", value: is_valid_phone(JSON.parse(input).blocks[0].text) }
    } catch (_) {
      return { kind: "simple", value: input && input != "" && is_valid_phone(input) }
    }
  }
  //Postcode check in ./validators in a separate function
  if (dependency.Kind == "IsPostcode") {
    try {
      console.log(JSON.parse(input).blocks[0].text)
      return {
        kind: "simple", value: is_valid_postcode(JSON.parse(input).blocks[0].text)
      }
    } catch (_) {
      return { kind: "simple", value: input && input != "" && is_valid_postcode(input) }
    }
  }

  if (dependency.Kind == "YourDonation") {
    let amount = 0

    let _amount = field.field.Id == 3 ? field.user_input : field_data_array.find(f => f.field.Id == 3)?.user_input
    if (_amount == "Other") {
      amount = +(field.field.Id == 4 ? field.user_input : field_data_array.find(f => f.field.Id == 4)?.user_input)
    }
    else {
      amount = +_amount
    }

    let frequency = field_data_array.find(f => f.field.Id == 2)?.user_input
    let target = field_data_array.find(f => f.field.Id == 1)?.user_input

    let your_donation = field_data_array.find(f => f.field.Id == 14)

    your_donation.user_input = `U doneert ${frequency?.toLocaleLowerCase()} een bedrag van ${amount} euro, bestemd voor ${target?.toLocaleLowerCase()} gebruik.`

    return { kind: "simple", value: true }
  }

  if (dependency.Kind == "YourInfo") {

    let name = field_data_array.find(f => f.field.Id == 5)?.user_input
    let surname = field_data_array.find(f => f.field.Id == 6)?.user_input
    let email = field_data_array.find(f => f.field.Id == 7)?.user_input
    let phone = field_data_array.find(f => f.field.Id == 8)?.user_input
    let street = field_data_array.find(f => f.field.Id == 12)?.user_input
    let house_number = field_data_array.find(f => f.field.Id == 10)?.user_input
    let house_addition = field_data_array.find(f => f.field.Id == 11)?.user_input
    let postcode = field_data_array.find(f => f.field.Id == 9)?.user_input
    let city = field_data_array.find(f => f.field.Id == 13)?.user_input

    let your_info = field_data_array.find(f => f.field.Id == 15)

    your_info.user_input = `<div>
      <div>${name} ${surname}</div>
      <div>${email}</div>
      <div>${phone || ""}</div>
      <div>${street || ""} ${house_number || ""} ${house_addition || ""}</div>
      <div>${postcode || ""} ${city || ""}</div>
    </div>`

    return { kind: "simple", value: true }
  }

  if (dependency.Kind == "IsPostcodeRemote") {
    try {
      //console.log(JSON.parse(input).blocks[0].text)
      return {
        kind: "async",
        value: async_queue<boolean>()(loadingAsyncState(async () => {

          let _postcode = dependency.dependent_fields_data[0]
          let _housenumber = dependency.dependent_fields_data[1]
          let _streetname = dependency.dependent_fields_data[2]
          let _city = dependency.dependent_fields_data[3]
          let _streetname_house_number = dependency.dependent_fields_data[4]

          let postcode = (field_data_array.find(f => f.field.Id == _postcode.field.Id).user_input || "").trim().replace(/ /g, '')
          let housenumber = (field_data_array.find(f => f.field.Id == _housenumber.field.Id).user_input || "").trim().replace(/ /g, '')
          let streetname = field_data_array.find(f => f.field.Id == _streetname.field.Id)
          let city = field_data_array.find(f => f.field.Id == _city.field.Id)
          let streetname_house_number = _streetname_house_number && field_data_array.find(f => f.field.Id == _streetname_house_number.field.Id)

          streetname.user_input = ""
          city.user_input = ""

          if (is_valid_postcode(postcode)) {

            if (housenumber == undefined || housenumber == "" || !isNumeric(housenumber)) {
              housenumber = "1"
            }
            let text = postcode + "/" + housenumber + "/"
            let res = await fetch(`/api/v1/WordPress/SearchPostcode/${text}`)
            if (res.ok) {
              let res_json = await res.json()


              streetname.user_input = res_json["street"]
              city.user_input = res_json["city"]
              if (streetname_house_number) {
                if (res_json["street"])
                  streetname_house_number.user_input = `${res_json["street"]} ${housenumber}`
                else
                  streetname_house_number.user_input = undefined
              }
            }
          }



          return { kind: "result", status: 200, value: true }
        }))
        //  value: is_valid_postcode(JSON.parse(input).blocks[0].text) 
      }
    } catch (_) {
      return { kind: "simple", value: input && input != "" && is_valid_postcode(input) }
    }
  }
  //Date check in ./validators in a separate function
  if (dependency.Kind == "IsDate") {
    return { kind: "simple", value: input && input != "" && is_valid_date(input) }
  }

  if (dependency.Kind == "EqualTo") {
    return { kind: "simple", value: input && input == dependency.value }
  }

  if (dependency.Kind == "FieldLengthMin") {
    if (field.field.Kind == "Text" || field.field.Kind == "TextArea") {
      input = get_text_from_draftjs(input)
    }
    try {
      let parsed = JSON.parse(input)
      console.log('cannot evaluate FieldLengthMin dependency on this field kind, returning False')
      return { kind: "simple", value: false }
    } catch (_) {
      return { kind: "simple", value: (input != undefined && input.split(' ').join('').length >= +dependency.value) && !((input == '' || input == undefined) && showMinMaxWarning) }
    }
  }


  if (dependency.Kind == "FieldLengthMax") {
    if (field.field.Kind == "Text" || field.field.Kind == "TextArea") {
      input = get_text_from_draftjs(input)
    }
    try {
      let parsed = JSON.parse(input)
      //console.log('cannot evaluate FieldLengthMax dependency on this field kind, returning False')

      let all_answers_lower_than_max = true
      parsed.forEach(input => {
        if (input && input.length > +dependency.value) {
          all_answers_lower_than_max = false
        }
      })
      return { kind: "simple", value: all_answers_lower_than_max }
    } catch (_) {
      return { kind: "simple", value: (input != undefined && input.split(' ').join('').length <= +dependency.value) && !((input == '' || input == undefined) && showMinMaxWarning) }
    }
  }

  if (dependency.Kind == "Contains") {

    let regex = new RegExp(dependency.value.startsWith("not ") ? dependency.value.replace("not ", "") : dependency.value, 'gu')
    let extraIsReg = regex.test(`extra: ${extra_input().join(', ')}`)
    if (field.field.Kind == 'MultiLineText') try {
      input = JSON.parse(input).blocks[0].text
    } catch (_) { }
    let inputIsReg = regex.test(input)
    if (dependency.value.startsWith("not")) {
      inputIsReg
    }
    return { kind: "simple", value: dependency.value.startsWith("not ") ? !(extraIsReg || inputIsReg) : (extraIsReg || inputIsReg) }
  }
}


export let get_all_fields = (state: FormState): FieldData[] => {
  if (state.form_data.kind != "loaded") return []
  let l1 = state.form_data.value.steps.flatMap(s => s.fields)
  let l2 = state.form_data.value.tabs.flatMap(t => t.sections.flatMap(s => s.steps.flatMap(s => s.fields)))
  return l1.concat(l2)

}



export let update_field_AUX = (fieldData: FieldData, user_input: string, formState: FormState): { fieldData: FieldData, dependencyState: DependenciesState } => {
  fieldData = { ...fieldData, user_input }
  let associated_dependencies = get_associated_dependencies(fieldData, formState)

  let dependencyState: DependenciesState = formState.dependencies_state
  let all_fields = get_all_fields(formState)
  let f = all_fields.find(f1 => f1.field.Id == fieldData.field.Id)
  if (f) {
    f.user_input = fieldData.user_input
  }
  associated_dependencies.forEach(dependency => {
    if (dependencyState.has(dependency.Id)) {
      let field_dep_state = dependencyState.get(dependency.Id).get(fieldData.field.Id)

      let dependency_result = get_dependency_result(fieldData, fieldData.user_input, formState.extra_input_for_dependency_check, dependency, all_fields, field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
      if (dependency_result.kind == "simple") {
        if (dependency_result.value == false) {
          dependencyState = dependencyState.set(dependency.Id,
            dependencyState.get(dependency.Id).set(fieldData.field.Id, dependency_result))
        }
        else {
          dependencyState = dependencyState.set(dependency.Id,
            dependencyState.get(dependency.Id).remove(fieldData.field.Id))
        }
      }
      else {
        if (dependency_result.kind == "async") {
          if (dependency_result.value.Result.kind == "loaded") {
            if (dependency_result.value.Result.value == false) {
              dependencyState = dependencyState.set(dependency.Id,
                dependencyState.get(dependency.Id).set(fieldData.field.Id, dependency_result))
            }
            else {
              dependencyState = dependencyState.set(dependency.Id,
                dependencyState.get(dependency.Id).remove(fieldData.field.Id))
            }
          }
          else {
            if (dependency_result.value.Result.kind == "unloaded") {
              dependencyState = dependencyState.set(dependency.Id,
                dependencyState.get(dependency.Id).remove(fieldData.field.Id))
            }
            else {
              dependencyState = dependencyState.set(dependency.Id,
                dependencyState.get(dependency.Id).set(fieldData.field.Id, dependency_result))
            }
          }
        }
      }
    }
  })

  return { fieldData, dependencyState }
}

//For the datepicker
import { IDatePickerStrings } from 'office-ui-fabric-react';
import { Entity } from 'ts-lenses';

export const DayPickerStrings: IDatePickerStrings = {
  months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],

  shortMonths: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],

  days: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],

  shortDays: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],

  goToToday: 'Ga naar vandaag',
  prevMonthAriaLabel: 'Vorige maand',
  nextMonthAriaLabel: 'Volgende maand',
  prevYearAriaLabel: 'Vorig jaar',
  nextYearAriaLabel: 'Volgend jaar',
  closeButtonAriaLabel: 'Sluiten'
};

export const FormatDate = (date: Date): string => {
  return date.getDate() + '-' + (date.getMonth() + 1) + '-' + (date.getFullYear() % 100);
}

export const ParseDateFromString = (value: string): Date => {
  const date = new Date(value) || new Date();
  const values = (value || '').trim().split('-');
  const day = values.length > 0 ? Math.max(1, Math.min(31, parseInt(values[0], 10))) : date.getDate();
  const month = values.length > 1 ? Math.max(1, Math.min(12, parseInt(values[1], 10))) - 1 : date.getMonth();
  let year = values.length > 2 ? parseInt(values[2], 10) : date.getFullYear();
  if (year < 100) {
    year += date.getFullYear() - (date.getFullYear() % 100);
  }
  return new Date(year, month, day);
}

export const ParseArrayFromString = (input: string): string[] => {
  let res: string[] = input ? JSON.parse(input) : []
  return res
}

export const ParseTableMap = (input: string): Map2<string> => {
  if (input == null || input.length == 0)
    return new Map<string, Map<string, string>>()
  else {
    let res: Array<[string, Array<[string, string]>]> = JSON.parse(input)
    let rval = new Map<string, Map<string, string>>()
    res.forEach(([key1, arr]) => {
      if (!rval.has(key1))
        rval.set(key1, new Map<string, string>())
      arr.forEach(([key2, val]) => {
        rval.get(key1).set(key2, val)
      })
    })
    return rval
  }
}

export function calculateCompletionRatio(
  formEntity: FieldData | StepData | SectionData | TabData | FormData,
  extra_input_for_dependency_check: () => Immutable.List<string>,
  formState: FormState
): [number, number] {
  const resultsReducer = (nestedResults: [number, number][]): [number, number] => nestedResults && nestedResults.length > 0 ? nestedResults.reduce(([accum1, accum2], [curr1, curr2]) => [accum1 + curr1, accum2 + curr2]) : [0, 0]
  try {
    let field = formEntity as FieldData
    if (!field.field)
      throw "Entity not a field"
    const input = get_text_from_draftjs(field.user_input)
    return input.length > 0 ? [1, 1] : [0, 1]
  } catch {
    try {
      let step = formEntity as StepData
      if (!step.step)
        throw "Entity not a step"

      step.fields.forEach(field => {
        if (field.field.Kind == 'RadioOption') {
          const found = field.maybe_answers.find((a) => field.user_input == a.value)
          if (found && found.nested_fields && found.nested_fields.length > 0) {
            found.nested_fields.forEach(f => get_associated_dependencies(f, formState).forEach(d =>
              step.dependencies.push({ dependency: d, dependent_fields: [{ FieldId: f.field.Id }], is_met: false })))
          }
        }

        else if (field.field.Kind == 'RadioOptionTable') {
          field.maybe_answers.forEach(ans => {
            if (field.user_input?.includes(`[${ans.value}]`) && ans.nested_fields && ans.nested_fields.length > 0)
              ans.nested_fields.forEach(f => get_associated_dependencies(f, formState).forEach(d =>
                step.dependencies.push({ dependency: d, dependent_fields: [{ FieldId: f.field.Id }], is_met: false })))
          })
        }

        else if (field.field.Kind == 'CheckboxMultiSelect') {
          field.maybe_answers.forEach(ans => {
            if (field.user_input?.includes(`[${ans.value}]`) && ans.nested_fields && ans.nested_fields.length > 0)
              ans.nested_fields.forEach(f => get_associated_dependencies(f, formState).forEach(d =>
                step.dependencies.push({ dependency: d, dependent_fields: [{ FieldId: f.field.Id }], is_met: false })))
          })
        }
      })  ///


      let all_fields = get_all_fields(formState)
      let step_is_hidden = false
      let important_deps = step.fields.map(field => {
        let filled_dependency: DependencyData = null
        step.dependencies.forEach(dependency => {
          if (!is_dependency_met(dependency.dependency, formState) && dependency.dependency.hideIfViolated)
            step_is_hidden = true
          dependency.dependent_fields.forEach(fieldId => {
            if (fieldId.FieldId == field.field.Id) {
              if (dependency.dependency.Kind == 'Filled')
                filled_dependency = dependency
              let dep_res = get_dependency_result(field, field.user_input, extra_input_for_dependency_check, dependency.dependency, all_fields)
              if (dep_res.value === false && dependency.dependency.hideIfViolated)
                step_is_hidden = true
            }
          })
        })
        return filled_dependency
      }).filter(dep => dep != null)
      if (step_is_hidden)
        return [0, 0]
      return resultsReducer(important_deps.map(dep => is_dependency_met(dep.dependency, formState) ? [1, 1] : [0, 1]))
    } catch {
      try {
        let section = formEntity as SectionData
        if (!section.section)
          throw "Entity not a section"
        return resultsReducer(section.steps.map(step => calculateCompletionRatio(step, extra_input_for_dependency_check, formState)))
      } catch {
        try {
          let tab = formEntity as TabData
          if (!tab.tab)
            throw "Entity not a tab"
          return resultsReducer(tab.sections.map(section => calculateCompletionRatio(section, extra_input_for_dependency_check, formState)))
        } catch {
          try {
            let form = formEntity as FormData
            if (!form.form)
              throw "Entity not a form"
            return resultsReducer(form.tabs.map(tab => calculateCompletionRatio(tab, extra_input_for_dependency_check, formState)))
          } catch {
            throw "Cannot calculate completion percentage"
          }
        }
      }
    }
  }
}

export function calculateCompletionPercentage<T extends FieldData | StepData | SectionData | TabData | FormData>(
  formEntity: T,
  extra_input_for_dependency_check: () => Immutable.List<string>,
  formState: FormState
): number {
  let completion_ratio = calculateCompletionRatio(formEntity, extra_input_for_dependency_check, formState)

  if (completion_ratio[0] == 0 && completion_ratio[1] == 0)
    return 100

  return completion_ratio[0] / completion_ratio[1] * 100
}

export const tuple = <T extends [any] | any[]>(args: T): T => args

export function findNextSection(formData: FormData, tabId?: number, sectionId?: number): [number, number] {
  if (tabId == null)
    return tuple([-1, -1])
  let tab_found = false
  let section_found = false
  return (() => {
    for (let i = 0; i < formData.tabs.length; i++) {
      let tab = formData.tabs[i]
      if (!tab_found) {
        if (tab.tab.Id == tabId) {
          tab_found = true
        }
      }
      if (tab_found) {
        for (let j = 0; j < tab.sections.length; j++) {
          let section = tab.sections[j]
          if (sectionId == null)
            sectionId = section.section.Id
          if (!section_found) {
            if (section.section.Id == sectionId) {
              section_found = true
            }
          }
          else {
            return tuple([tab.tab.Id, section.section.Id])
          }
        }
      }
    }
    return tuple([-1, -1])
  })()
}

// export function recalculateAllCompletionPercentages(appState: FormAppState): FormAppState {
//   const form_data = appState.formState.form_data
//   if (form_data.kind != 'loaded')
//     return appState
//   else {
//     const new_appState = Entity(appState).set('form_completion_percentage', map => {
//       map.set(form_data.value.form.Id, calculateCompletionPercentage(form_data.value, appState.formState.extra_input_for_dependency_check, appState.formState))
//       return map
//     })
//       .set('tab_completion_percentage', map => {
//         form_data.value.tabs.forEach(tab => map.set(tab.tab.Id, calculateCompletionPercentage(tab, appState.formState.extra_input_for_dependency_check, appState.formState)))
//         return map
//       })
//       .set('section_completion_percentage', map => {
//         let sections = form_data.value.tabs.flatMap(tab => tab.sections)
//         sections.forEach(section => map.set(section.section.Id, calculateCompletionPercentage(section, appState.formState.extra_input_for_dependency_check, appState.formState)))
//         return map
//       })
//       .commit()
//     return new_appState
//   }
// }

export function get2<T>(map: Map2<T>, key1: string, key2: string): T {
  if (!map.has(key1))
    return undefined
  if (!map.get(key1).has(key2))
    return undefined
  return map.get(key1).get(key2)
}

export function set2<T>(map: Map2<T>, key1: string, key2: string, val: T): Map2<T> {
  if (!map.has(key1))
    map.set(key1, new Map<string, T>().set(key2, val))
  else
    map.get(key1).set(key2, val)
  return map
}

export const max = (left: number, right: number): number => left >= right ? left : right

export const LCS = (left: string, right: string): number => {
  let dp = new Array<Array<number>>(left.length + 1).fill(new Array<number>(right.length + 1))
  for (let i = 0; i <= left.length; i++)
    for (let j = 0; j <= right.length; j++) {
      if (i == 0 || j == 0)
        dp[i][j] = 0
      else if (left.charAt(i - 1) == right.charAt(j - 1))
        dp[i][j] = dp[i - 1][j - 1] + 1
      else
        dp[i][j] = max(dp[i - 1][j], dp[i][j - 1])
    }
  return dp[left.length][right.length]
}

// export const calculateFieldUserInput = (field: Model.Field, school: Model.School): string => {
//   let schoolkeys = Object.keys(school)
//   schoolkeys = schoolkeys.sort((a, b) => {
//     if (a == field.title)
//       return Number.NEGATIVE_INFINITY
//     if (b == field.title)
//       return Number.POSITIVE_INFINITY
//     let lcsb = LCS(field.title.toLowerCase(), b.toLowerCase())
//     let lcsa = LCS(field.title.toLowerCase(), a.toLowerCase())
//     if (lcsb == lcsa)
//       return a.length - b.length
//     return lcsb - lcsa
//   })
//   return school[schoolkeys[0]]
// }

// export const schoolFormToSchoolModel = (data_f: FormData, school: Model.School): SchoolFormData => {
//   let contactDataFields = data_f.tabs[0].sections[0].steps.filter(x => x.step.title.toLocaleLowerCase().includes("contactgegevens schoollocatie"))[0].fields.map(field => {
//     try {
//       return {...field, user_input: JSON.parse(field.user_input).blocks[0].text}
//     } catch (_) {
//       return field
//     }
//   })
//   let contactPersonFields = data_f.tabs[0].sections[0].steps.filter(x => x.step.title.toLocaleLowerCase().includes("contactpersonen"))[0].fields.map(field => {
//     try {
//       return {...field, user_input: JSON.parse(field.user_input).blocks[0].text}
//     } catch (_) {
//       return field
//     }
//   })
//   return {
//     School: { ...school,
//       VisitingAddress: contactDataFields.find(field => field.field.Kind == 'Text' && field.field.placeholder == "VisitingAddress").user_input,
//       VisitingPostcode: contactDataFields.find(field => field.field.Kind == 'Text' && field.field.placeholder == "VisitingPostcode").user_input,
//       VisitingCity: contactDataFields.find(field => field.field.Kind == 'Text' && field.field.placeholder == "VisitingCity").user_input,
//       MailingAddress: contactDataFields.find(field => field.field.Kind == 'Text' && field.field.placeholder == "MailingAddress").user_input,
//       MailingPostcode: contactDataFields.find(field => field.field.Kind == 'Text' && field.field.placeholder == "MailingPostcode").user_input,
//       MailingCity: contactDataFields.find(field => field.field.Kind == 'Text' && field.field.placeholder == "MailingCity").user_input,
//       Phone: contactDataFields.find(field => field.field.title == "Telefoonnummer schoollocatie").user_input,
//       Email: contactDataFields.find(field => field.field.title == "E-mailadres schoollocatie").user_input,
//       Website: contactDataFields.find(field => field.field.title == "Website schoollocatie").user_input
//     },
//     CareCoordinator: contactPersonFields.find(field => field.field.title.includes("Ondersteuningscoördinator")).user_input,
//     Supervisor: contactPersonFields.find(field => field.field.title.includes("Begeleider passend onderwijs")).user_input,
//     ContactPersonAdmissions: contactPersonFields.find(field => field.field.title.includes("Contactpersoon toelating")).user_input,
//     ConfidentialCounselor: contactPersonFields.find(field => field.field.title.includes("Vertrouwenspersoon voor ouders")).user_input
//   }
// }

// export const schoolModelToSchoolForm = (school: Model.School, data_f: FormData): FormData => ({...data_f,
//   tabs: data_f.tabs.map(tab => ({...tab,
//     sections: tab.sections.map(section => ({...section, 
//       steps: section.steps.map(step => ({...step,
//         fields: step.fields.map(field => {
//           try {
//             let temp = JSON.parse(field.user_input)
//             return field
//           } catch (_) {
//             if (field.field.Kind != 'MultiLineText' && field.field.Kind != 'Text')
//               return field
//             return {...field,
//               user_input: 
//                 field.field.Kind == "Text" 
//                 ? field.field.placeholder == "VisitingAddress" ? school.VisitingAddress
//                   : field.field.placeholder == "VisitingPostcode" ? school.VisitingPostcode
//                   : field.field.placeholder == "VisitingCity" ? school.VisitingCity
//                   : field.field.placeholder == "MailingAddress" ? school.MailingAddress
//                   : field.field.placeholder == "MailingPostcode" ? school.MailingPostcode
//                   : field.field.placeholder == "MailingCity" ? school.MailingCity
//                   : ""
//                 : field.field.title == "Telefoonnummer schoollocatie" ? school.Phone
//                 : field.field.title == "E-mailadres schoollocatie" ? school.Email
//                 : field.field.title == "Website schoollocatie" ? school.Website
//                 : field.field.title == "Contactpersoon toelating" ? school.ContactPersonAdmissions
//                 : field.field.title == "Vertrouwenspersoon voor ouders" ? school.ConfidentialCounselor
//                 : ""
//             }
//           }
//         })
//       }))
//     }))
//   }))
// })

// export const prFormToPrModel = (data_f: FormData, pr: Model.PublicRelation): Model.PublicRelation => {
//   let rval: Model.PublicRelation = pr
//   data_f.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(step => step.fields.forEach(field => {
//     switch (field.field.title) {
//       case 'Facebook':
//         rval.Facebook = field.user_input
//         break
//       case 'Twitter':
//         rval.Twitter = field.user_input
//         break
//       case 'Instagram':
//         rval.Instagram = field.user_input
//         break
//       case 'Fotos':
//         rval.Photos = field.user_input
//         break
//       case 'Logo':
//         rval.Logo = field.user_input
//         break
//       default:
//         throw `Form field with title ${field.field.title} does not correspond to a PublicRelation attribute`
//     }
//   }))))
//   return rval
// }

// export const addSchoolToUserInput = (data_f: FormData, schoolFormData: SchoolFormData): FormData =>
//   Entity<FormData>(data_f).set("tabs", tabs => tabs.map(tab =>
//     Entity<TabData>(tab).set("sections", sections => sections.map(section =>
//       Entity<SectionData>(section).set("steps", steps => steps.map(step =>
//         Entity<StepData>(step).set("fields", fields => fields.map(field =>
//           Entity<FieldData>(field).set("user_input", _ => {
//             let user_input = ""
//             switch (field.field.title.toLocaleLowerCase()){
//               case "telefoonnummer schoollocatie":
//                 return user_input = schoolFormData.School.Phone

//               case "e-mailadres schoollocatie":
//                 return user_input = schoolFormData.School.Email

//               case "website schoollocatie":
//                 return user_input = schoolFormData.School.Website

//               case "ondersteuningscoördinator (zichtbaar op website)":
//                 return user_input = schoolFormData.CareCoordinator

//               case "begeleider passend onderwijs":
//                 return user_input = schoolFormData.Supervisor

//               case "contactpersoon toelating (zichtbaar op website)":
//                 return user_input = schoolFormData.ContactPersonAdmissions

//               case "vertrouwenspersoon voor ouders (zichtbaar op website)":
//                 return user_input = schoolFormData.ConfidentialCounselor

//               default:
//                 if (field.field.Kind == "Text")
//                 switch (field.field.placeholder) {

//                     case "VisitingAddress":
//                       return schoolFormData.School.VisitingAddress

//                     case "VisitingPostcode":
//                       return schoolFormData.School.VisitingPostcode

//                     case "VisitingCity":
//                       return schoolFormData.School.VisitingCity

//                     case "MailingAddress":
//                       return schoolFormData.School.MailingAddress

//                     case "MailingPostcode":
//                       return schoolFormData.School.MailingPostcode

//                     case "MailingCity":
//                       return schoolFormData.School.MailingCity
//                   }
//                 }
//               })
//             .commit()))
//           .commit()))
//         .commit()))
//       .commit()))
//     .commit()

// export const addPRToUserInput = (data_f: FormData, pr: Model.PublicRelation): FormData =>
//   Entity<FormData>(data_f).set("tabs", tabs => tabs.map(tab =>
//     Entity<TabData>(tab).set("sections", sections => sections.map(section =>
//       Entity<SectionData>(section).set("steps", steps => steps.map(step =>
//         Entity<StepData>(step).set("fields", fields => fields.map(field =>
//           Entity<FieldData>(field).set("user_input", _ => {
//             switch (field.field.title) {
//               case 'Twitter':
//                 return pr.Twitter
//               case 'Facebook':
//                 return pr.Facebook
//               case 'Instagram':
//                 return pr.Instagram
//               case 'Fotos':
//                 return pr.Photos
//               case 'Logo':
//                 return pr.Logo
//               default:
//                 throw `Unknown field title ${field.field.title}`
//             }
//           })
//             .commit()))
//           .commit()))
//         .commit()))
//       .commit()))
//     .commit()

export function calculateDependenciesOutput(
  formEntity: StepData | SectionData | TabData | FormData,
  formState: FormState
): GenericDependencyOutput {
  const resultsReducer = (nestedResults: GenericDependencyOutput[]): GenericDependencyOutput => {
    if (!nestedResults || nestedResults && nestedResults.length == 0)
      return { kind: 'yes' }
    let unmet_deps: UnmetDependencyOutput[] = nestedResults.filter(res => res.kind == 'no').map(res => res as UnmetDependencyOutput)
    let not_reviewed_deps: NotReviewedDependencyOutput[] = nestedResults.filter(res => res.kind == 'not_reviewed').map(res => res as NotReviewedDependencyOutput)
    if (unmet_deps.length == 0 && not_reviewed_deps.length == 0)
      return { kind: 'yes' }
    if (not_reviewed_deps.length > 0)
      return { kind: 'not_reviewed' }
    return { kind: 'no', messages: Immutable.List<string>([].concat(unmet_deps.map(res => res.kind == 'no' && res.messages.toArray()))) }
  }
  try {
    let step = formEntity as StepData
    if (!step.step)
      throw "Entity not a step"

    let all_nested_fields1 = Immutable.List(step.fields).toArray()
    step.fields.forEach(field => {
      let traverse_field = (field: FieldData): void => {
        if (field.field.Kind == 'RadioOption') {
          const found = field.maybe_answers.find((a) => field.user_input == a.value)
          if (found && found.nested_fields && found.nested_fields.length > 0) {
            found.nested_fields.forEach(f => {
              traverse_field(f)
              let deps = get_associated_dependencies(f, formState).filter(d => d.Kind != "Contains")
              if (deps.count() > 0) {
                all_nested_fields1.push(f)
              }
              deps.forEach(d => {
                if (step.dependencies.filter(d1 => d1.dependency.Id == d.Id).length == 0)
                  step.dependencies.push({ dependency: d, dependent_fields: [{ FieldId: f.field.Id }], is_met: true })
              })
            })
          }
        }

        else if (field.field.Kind == 'RadioOptionTable' || field.field.Kind == 'CheckboxMultiSelect') {
          field.maybe_answers.forEach(ans => {
            if (field.user_input?.includes(`[${ans.value}]`) && ans.nested_fields && ans.nested_fields.length > 0)
              ans.nested_fields.forEach(f => {
                traverse_field(f)
                get_associated_dependencies(f, formState).forEach(d => {
                  all_nested_fields1.push(f)
                  step.dependencies.push({ dependency: d, dependent_fields: [{ FieldId: f.field.Id }], is_met: true })
                })
              })
          })
        }
      }
      traverse_field(field)
    })  ///

    let step_is_hidden = false
    let results: GenericDependencyOutput[] = []

    step.dependencies.forEach(dep =>
      all_nested_fields1.forEach(field => {
        let traverse_field_dependencies = (field: FieldData) => {
          if (!is_dependency_met(dep.dependency, formState)) {
            if (dep.dependency.hideIfViolated)
              step_is_hidden = true
            let touched = false
            dep.dependent_fields.forEach(fieldId => {
              if (fieldId.FieldId == field.field.Id) {
                touched = true
                const res = are_dependencies_met(field, formState)
                if (res.kind == 'no') {
                  if (dep.dependency.hideIfViolated)
                    step_is_hidden = true
                  if (dep.dependency.lockSubmissionIfViolated)
                    results.push(res)
                }
                else
                  results.push(res)
              }
            })
            if (!touched) { //nested field dep here
              dep.dependent_fields.forEach(fieldId => {
                let found_nested_field = all_nested_fields1.find(f => f.field.Id == fieldId.FieldId)
                if (found_nested_field)
                  results.push(are_dependencies_met(found_nested_field, formState))
              })
            }
          }
        }
        traverse_field_dependencies(field)
      }))

    let rval = resultsReducer(results)
    return rval.kind == 'no' && step_is_hidden ? { kind: 'yes' } : rval

  } catch {
    try {
      let section = formEntity as SectionData
      if (!section.section)
        throw "Entity not a section"
      if (!section.section.reviewed) {
        return { kind: 'not_reviewed' }
      }
      return resultsReducer(section.steps.map(step => calculateDependenciesOutput(step, formState)))
    } catch {
      try {
        let tab = formEntity as TabData
        if (!tab.tab)
          throw "Entity not a tab"
        return resultsReducer(tab.sections.map(section => calculateDependenciesOutput(section, formState)))
      } catch {
        try {
          let form = formEntity as FormData
          if (!form.form)
            throw "Entity not a form"
          return resultsReducer(form.tabs.map(tab => calculateDependenciesOutput(tab, formState)))
        } catch {
          throw "Cannot calculate dependency output"
        }
      }
    }
  }
}

export function stepIsHidden(step: StepData, formState: FormState): boolean {
  let step_is_hidden = false

  step.dependencies.forEach(dep => {
    if (!is_dependency_met(dep.dependency, formState) && dep.dependency.hideIfViolated)
      step_is_hidden = true
  })

  return step_is_hidden
}

// export function calculateFormCompletionPercentage(formData: FormData): number {
//   const results = formData.tabs.flatMap(tab => tab.sections.map(section => section.section.reviewed))
//   if (results.length == 0)
//     return 0
//   return results.filter(val => val).length / results.length * 100
// }

export function isTabFilled(tab: TabData): boolean {
  const results = tab.sections.map(section => section.section.reviewed)
  if (results.length == 0)
    return false
  return results.filter(val => val).length === results.length
}

